module.exports = "/images/step3.png?f547f7d63ed82279fc27493153554cb7";